var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H120V120H0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5522 100.281L40.735 94.7232C42.5069 97.8643 44.1185 100.522 47.9843 100.522C51.6897 100.522 54.0264 99.0727 54.0264 93.4346V55.0918H65.3032V93.594C65.3032 105.274 58.4566 110.59 48.4675 110.59C39.4464 110.59 34.21 105.918 31.5518 100.28L31.5522 100.281ZM71.4283 99.0722L80.6102 93.7562C83.0275 97.7035 86.1691 100.603 91.7266 100.603C96.3996 100.603 99.3789 98.2669 99.3789 95.0447C99.3789 91.1785 96.318 89.8088 91.1627 87.5541L88.3441 86.3447C80.208 82.8821 74.8113 78.5321 74.8113 69.3493C74.8113 60.8912 81.2552 54.4468 91.3244 54.4468C98.4935 54.4468 103.649 56.9443 107.354 63.4688L98.5732 69.1079C96.6396 65.6443 94.5461 64.2751 91.3239 64.2751C88.0211 64.2751 85.9268 66.3694 85.9268 69.1079C85.9268 72.4908 88.0211 73.861 92.8539 75.9554L95.673 77.1633C105.259 81.2719 110.656 85.4602 110.656 94.884C110.656 105.034 102.681 110.592 91.968 110.592C81.4966 110.592 74.7302 105.598 71.4279 99.0727",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathJavascript);
export default __webpack_public_path__ + "static/media/path-javascript.66c530d5f869cdef5f47e0547c611dbf.svg";
export { ForwardRef as ReactComponent };